<div class="[ stack stack-space-3xs ]" data-cy="adaptive-module">
  <ng-content select="campus-toc-header"></ng-content>

  @if (showProgress) {
    <div class="[ flex-none ]">
      <ng-content select="campus-segmented-progress-bar"></ng-content>
    </div>
    <div class="[ flex justify-between ]">
      <span class="[ label-small opacity-low ]">Begin van de les</span>
      <span class="[ label-small opacity-low ]">Helemaal klaar!</span>
    </div>
  }
</div>

<ng-content></ng-content>
